export default __webpack_public_path__ + "static/media/puffer_cell_men.18bf281d.jpg";